import { ca } from '@cian/analytics';

import { NEW_OBJECTS_KEYS, TIndexableObject } from '../../interfaces/villages';
import { generateTrackingPageViewObject } from './generateTrackingPageViewObject';
import { IApplicationState } from '../../types/store';

export type TGeoSuggestEventLabel =
  | 'region/cian'
  | 'district/cian'
  | 'city/cian'
  | 'street/yandex'
  | 'metro/yandex'
  | 'railways/cian'
  | 'jk/cian'
  | 'builder/cian'
  | 'KP/cian';

export const trackOpenFeedbackForm = () => {
  ca('event', {
    action: 'show',
    category: 'KPDeveloperForm',
    label: '',
    name: 'oldevent',
  });
};

export const trackCloseFeedbackForm = () => {
  ca('event', {
    action: 'close',
    category: 'KPDeveloperForm',
    label: '',
    name: 'oldevent',
  });
};

export const trackSubmitFeedbackForm = () => {
  ca('event', {
    action: 'submit',
    category: 'KPDeveloperForm',
    label: '',
    name: 'oldevent',
  });
};

export function trackFindOnNotFoundPageClick() {
  ca('eventSite', {
    category: '404',
    action: 'find',
  });
}

export const trackOpenMobileFeedbackForm = () => {
  ca('event', {
    action: 'step1',
    category: 'KPDeveloperForm',
    label: '',
    name: 'oldevent',
  });
};

export const trackGoMobileFeedbackStep2 = () => {
  ca('event', {
    action: 'step2',
    category: 'KPDeveloperForm',
    label: '',
    name: 'oldevent',
  });
};

export const ANALYTICS_OBJECT_TYPES: TIndexableObject = {
  [NEW_OBJECTS_KEYS.COTTAGE]: 'cottage',
  [NEW_OBJECTS_KEYS.TOWNHOUSE]: 'townhouse',
  [NEW_OBJECTS_KEYS.LOWRISEHOUSE]: 'Малоэтажные дома',
  [NEW_OBJECTS_KEYS.LANDPLOT]: 'uchastok',
};

export const trackPageView = (state: IApplicationState) =>
  ca('pageviewSite', {
    ...generateTrackingPageViewObject(state),
    category: 'page',
    action: 'newpage',
  });

export const trackGeoSuggestItemClick = (label: TGeoSuggestEventLabel) => {
  ca('event', {
    action: 'Change',
    category: 'GeoSuggest',
    label,
    name: 'oldevent',
  });
};
